import React, { useRef, useState } from 'react';
import { LogClick } from '../ClickStream';
import FeedbackModal from './FeedbackModal';
import { CircleButton, FeedbackButtonText, Row } from './FeedbackStyled';
import { HelpFilledIcon as HelpFilled } from '@gr-monorepo/common/public/assets/icons';
import { Space } from '@gr-monorepo/common/ui';

const Feedback = () => {
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <LogClick eventType="feedback_open" eventInfo={`Нажал открыть обратную связь`}>
        <CircleButton
          ref={buttonRef}
          onClick={() => {
            setShowModal(!showModal);
          }}
          style={{ position: 'fixed', bottom: 24, right: 40, zIndex: 1005 }}
          data-testid="feedback-button"
        >
          <Row>
            <HelpFilled width={20} height={20} />
            <Space size={6} axis="horizontal" />
            <FeedbackButtonText>Помощь</FeedbackButtonText>
          </Row>
        </CircleButton>
      </LogClick>
      {showModal && <FeedbackModal onClose={closeModal} />}
    </>
  );
};

export default Feedback;
